/**
 * Feature flags for the application
 * These flags control premium features that can be enabled/disabled per deployment
 */

export const FEATURE_FLAGS = {
    // AI Image Editing Feature - Enable for subscribed stores only
    // Controlled via REACT_APP_AI_IMAGE_EDITING in .env file
    AI_IMAGE_EDITING: process.env.REACT_APP_AI_IMAGE_EDITING === 'true',
};

/**
 * Check if a feature is enabled
 * @param {string} featureName - Name of the feature from FEATURE_FLAGS
 * @returns {boolean} - Whether the feature is enabled
 */
export const isFeatureEnabled = (featureName) => {
    return FEATURE_FLAGS[featureName] === true;
};

// NOTE: Subscription plan limits are now enforced server-side in Cloud Functions
